import { RequireAuth, useFusionAuth } from "@fusionauth/react-sdk";
import { Box, Button, Divider, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import BasePage from "../../components/layout/BasePage.tsx";
import Header from "../../components/layout/Header.tsx";
import { NavBarContext } from "../../contexts/NavBarContext.tsx";
import CreateProject from "../projectCreate/CreateProject.tsx";
import ProjectTable from "./ProjectTable.tsx";

export default function Home() {
  const [startProjectOpen, setStartProjectOpen] = useState(false);
  const { userInfo } = useFusionAuth();
  const { company } = useContext(NavBarContext);

  // coalesce user first name, user full, name or nothing
  const name = userInfo?.given_name || userInfo?.name || undefined;

  return (
    <BasePage className="landing-box">
      <Header text={`Let's get started${name ? `, ${name}` : ""}!`}>
        <Typography variant="h6" sx={{ color: "white" }}>
          {company?.name}
        </Typography>
        <RequireAuth withRole="ADMIN">
          <div className="header-form-box">
            <Button
              variant="contained"
              onClick={() => setStartProjectOpen(true)}
              sx={{ boxShadow: 2 }}
              color="secondary"
            >
              Start a Project
            </Button>
          </div>
        </RequireAuth>
      </Header>
      <Divider />
      <Box className="body-box" sx={{ bgcolor: "grey.50" }}>
        <ProjectTable handleStartProject={() => setStartProjectOpen(true)} />
      </Box>
      {startProjectOpen && (
        <CreateProject onCancel={() => setStartProjectOpen(false)} />
      )}
    </BasePage>
  );
}
